import Internet from './Internet';
export default Internet;



// WEBPACK FOOTER //
// ./src/components/Internet/index.js